import { render } from "./index.vue?vue&type=template&id=7fcd1336&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7fcd1336&scoped=true&lang=css"

import exportComponent from "/home/tobias/code/github.com/RemondisDigitalServices/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcd1336"]])

export default __exports__